// Dialog "Chuyển bộ" — hiện 6 bộ còn lại (loại bộ hiện tại).
// PRD R-P0-B8: move không re-embed, không tự động duyệt.
import { useState } from 'react';
import toast from 'react-hot-toast';
import { BO_MOVE_TARGETS, boLabel } from '../lib/bo.js';

export default function MoveBoDialog({ open, question, onClose, onConfirm }) {
  const [target, setTarget] = useState('');
  const [saving, setSaving] = useState(false);

  if (!open || !question) return null;

  const options = BO_MOVE_TARGETS.filter((b) => b !== question.bo);

  async function handleConfirm() {
    if (!target) return toast.error('Chọn bộ đích');
    setSaving(true);
    try {
      await onConfirm(target);
    } catch (err) {
      toast.error(err?.data?.error || err?.message || 'Lỗi chuyển bộ');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="border-b px-5 py-3">
          <h3 className="text-lg font-semibold">Chuyển bộ</h3>
          <p className="text-xs text-slate-500 mt-1">
            Câu hiện ở <b>{boLabel(question.bo)}</b>. Chọn bộ đích:
          </p>
        </div>

        <div className="p-5">
          <select value={target} onChange={(e) => setTarget(e.target.value)}
                  className="w-full border rounded px-3 py-2" autoFocus>
            <option value="">— chọn bộ —</option>
            {options.map((b) => <option key={b} value={b}>{boLabel(b)}</option>)}
          </select>
          <div className="mt-3 text-xs text-slate-500">
            Lưu ý: Không thể chuyển về <b>Chờ duyệt</b> (không có chiều ngược).
          </div>
        </div>

        <div className="border-t px-5 py-3 flex justify-end gap-2">
          <button onClick={onClose} disabled={saving}
                  className="px-4 py-2 border rounded hover:bg-slate-50">Huỷ</button>
          <button onClick={handleConfirm} disabled={saving || !target}
                  className="px-4 py-2 bg-slate-800 text-white rounded hover:bg-slate-900 disabled:opacity-50">
            {saving ? 'Đang chuyển…' : 'Chuyển'}
          </button>
        </div>
      </div>
    </div>
  );
}
